import "core-js/modules/es.object.to-string";
import { ROUTE_NAME } from './constant';
export var routes = [{
  path: '/triangle/index/:activityId',
  name: ROUTE_NAME.INDEX,
  meta: {
    title: '报名'
  },
  component: function component() {
    return import(
    /* webpackChunkName: "triangle" */
    './pages/index.vue');
  }
}, {
  path: '/triangle/home/:activityId/',
  name: ROUTE_NAME.HOME,
  meta: {
    title: '铁三角'
  },
  component: function component() {
    return import(
    /* webpackChunkName: "triangle" */
    './pages/home.vue');
  }
}, {
  path: '/triangle/invitation/:activityId/:userId/:groupId',
  name: ROUTE_NAME.INVITATION,
  meta: {
    title: '铁三角'
  },
  component: function component() {
    return import(
    /* webpackChunkName: "triangle" */
    './pages/invitation.vue');
  }
}];